import { APICore } from 'src/helpers/api/apiCore';
import config from 'src/config';
const apiBaseUrl = config.API_URL;
const api = new APICore();

// add Range Def
function creatRangeDef(params: any) {
    const baseUrl = `/rangeDef/createRangeDef`;
    return api.create(`${baseUrl}`, params);
}
// update Range Def
function updateRangeDef(params: any) {
    const baseUrl = '/rangeDef/updateRangeDef';
    return api.update(`${baseUrl}`, params);
}

// get all Range Defs
function getAllRangeDefs(params: any) {
    const baseUrl = '/rangeDef/getAllRangeData';
    return api.create(`${baseUrl}`, params);
}

// get Range Def Detail
function getRangeDef(params: any) {
    const baseUrl = '/rangeDef/getRangeUOMDetail';
    return api.create(`${baseUrl}`, params);
}

export { creatRangeDef, updateRangeDef, getAllRangeDefs, getRangeDef };
